import { Input, Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { GeneratePdfService } from '../services/pdf/generate-pdf.service';

@Component({
  selector: 'app-confirm-payment',
  templateUrl: './confirm-payment.component.html',
  styleUrls: ['./confirm-payment.component.scss']
})
export class ConfirmPaymentComponent implements OnInit, OnChanges {

  @Input() paymentFinal: any;
  myDate = new Date();
  fechaActual = new Date();
  comprobante = null;

  constructor(private pdfService: GeneratePdfService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['paymentFinal'].firstChange) {
      this.paymentFinal = changes['paymentFinal'].currentValue;
    } else {
      if (changes['paymentFinal'].currentValue.projectId !== changes['paymentFinal'].previousValue.projectId) {
        this.paymentFinal = changes['paymentFinal'].currentValue;
      }
    }
  }

  formatNumber(number: string) {
    let numberStr = number.toString();
    if (numberStr.indexOf('.') === -1) {
      // No decimal point, add ",00" for cents
      numberStr += ",00";
    } else {
      // Replace the decimal point with a comma
      numberStr = numberStr.replace('.', ',');
    }
    let parts = numberStr.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
  }

  descargarComprobante() {
    const fecha = new Date();
    const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun',
                  'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];
    const dia = fecha.getDate();
    const mes = meses[fecha.getMonth()];
    const año = fecha.getFullYear();
    const horas = fecha.getHours();
    const minutos = fecha.getMinutes().toString().padStart(2, '0');
    const segundos = fecha.getSeconds().toString().padStart(2, '0');

    const horas12 = horas === 0 ? 12 : (horas > 12 ? horas - 12 : horas);
    const ampm = horas < 12 ? 'a.m.' : 'p.m.';
    const fechaFormateada = `${dia} ${mes} ${año}, ${horas12}:${minutos}:${segundos} ${ampm}`;

    const consecutivo = this.paymentFinal?.paymentInformation?.consecutive ?? ' Sin consecutivo';

    const objPdf = {
      comprobante: `OPC${consecutivo}`,
      titulo: 'Pago por proyecto',
      fechaYHora: fechaFormateada,
      direccionIp: this.paymentFinal.ip,
      proyecto: this.paymentFinal.name_project_selected,
      valor: this.formatNumber(this.paymentFinal.amount),
      tituloCuenta: this.paymentFinal.tittleAccount,
      numeroCuenta: this.paymentFinal.account,
      tipoCuenta: this.paymentFinal.type,
      projectId: this.paymentFinal.projectId
    }

    this.pdfService.generarPdfPagoProyecto(objPdf);
  }
}







